/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  in: (key, values) => {
    const formattedValues = values.map(value => `${value}`)
    return `${key.replace(/:in/g, '')} in (${formattedValues.join(' ')})`
  }
}

const filterMappings = {
  'status': queryFiltersMappings.eq,
}

export default filterMappings
